import YearlySalesManagementPage from './YearlySalesManagementPage';

export default YearlySalesManagementPage;
